import {
  Config,
  type ComponentSizeType,
  type LanguageType,
  type ThemeType,
} from '@contiple/antd-ds';

export interface AppSettings {
  theme: ThemeType;
  language: LanguageType;
  componentSize: ComponentSizeType;
  lnbExpanded: boolean;
}

export const DEFAULT_SETTINGS: AppSettings = {
  theme: Config.Theme.CONTIPLE,
  language: Config.Language.KO,
  componentSize: Config.ComponentSize.MEDIUM,
  lnbExpanded: true,
};

export const APP_SETTINGS_KEY = 'console_settings';

export const saveSettings = (settings: Partial<AppSettings>) => {
  try {
    const currentSettings = loadSettings();
    const newSettings = { ...currentSettings, ...settings };
    localStorage.setItem(APP_SETTINGS_KEY, JSON.stringify(newSettings));
  } catch (error) {
    console.error('Failed to save settings:', error);
  }
};

export const loadSettings = (): AppSettings => {
  try {
    const settings = localStorage.getItem(APP_SETTINGS_KEY);
    if (settings) {
      return { ...DEFAULT_SETTINGS, ...JSON.parse(settings) };
    }
  } catch (error) {
    console.error('Failed to load settings:', error);
  }
  return DEFAULT_SETTINGS;
};
